// import { useState, useEffect } from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import axios from 'axios';
// import './MahaprasadBooking.css';

// const API_BASE = 'http://localhost:8000/api';

// /* status pill helper */
// function StatusPill({ status }) {
//   const cls = {
//     confirmed: 'status-confirmed',
//     pending:   'status-pending',
//     cancelled: 'status-cancelled',
//     shifted:   'status-shifted',
//   }[status] || 'status-pending';

//   return <span className={`status-pill ${cls}`}>{status}</span>;
// }

// function MahaprasadBooking() {

//       const { t } = useLanguage();

//   /* ── Login state ── */
//   const [step, setStep]           = useState(1);
//   const [email, setEmail]         = useState('');
//   const [otp, setOtp]             = useState('');
//   const [otpSent, setOtpSent]     = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otpError, setOtpError]   = useState('');

//   /* ── Booking state ── */
//   const [dates, setDates]           = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [remaining, setRemaining]   = useState(0);
//   const [formData, setFormData]     = useState({ name: '', phone: '' });
//   const [error, setError]           = useState('');
//   const [success, setSuccess]       = useState('');
//   const [loading, setLoading]       = useState(false);
//   const [myBookings, setMyBookings] = useState([]);

//   /* ── Auto login on refresh ── */
//   useEffect(() => {
//     const token      = localStorage.getItem('token');
//     const savedEmail = localStorage.getItem('user_email');
//     if (token && savedEmail) {
//       setEmail(savedEmail);
//       setStep(2);
//       fetchMyBookings();
//     }
//   }, []);

//   /* ── Fetch available dates ── */
//   useEffect(() => {
//     if (step !== 2) return;
//     axios.get(`${API_BASE}/mahaprasad`)
//       .then(res => setDates(res.data))
//       .catch(console.error);
//   }, [step]);

//   /* ── Fetch remaining slots ── */
//   useEffect(() => {
//     if (!selectedDate) return;
//     axios.get(`${API_BASE}/mahaprasad/slots/${selectedDate}`)
//       .then(res => setRemaining(res.data.remaining || 0))
//       .catch(console.error);
//   }, [selectedDate]);

//   /* ── OTP ── */
//   const sendOtp = async () => {
//     if (!email) { setOtpError('Please enter your email'); return; }
//     setOtpLoading(true); setOtpError('');
//     try {
//       await axios.post(`${API_BASE}/send-otp`, { email });
//       setOtpSent(true);
//     } catch {
//       setOtpError('Failed to send OTP. Please try again.');
//     }
//     setOtpLoading(false);
//   };

//   const verifyOtp = async () => {
//     try {
//       const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
//       localStorage.setItem('token', res.data.token);
//       localStorage.setItem('user_email', email);
//       setStep(2);
//       fetchMyBookings();
//     } catch {
//       setOtpError('Invalid OTP. Please try again.');
//     }
//   };

//   /* ── My Bookings ── */
//   const fetchMyBookings = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/mahaprasad/my-bookings`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       setMyBookings(res.data);
//     } catch { /* silent */ }
//   };

//   /* ── Book ── */
//   const handleBook = async () => {
//     if (!selectedDate || !formData.name || !formData.phone) {
//       setError('Please fill all required fields'); return;
//     }
//     setLoading(true); setError(''); setSuccess('');
//     try {
//       await axios.post(
//         `${API_BASE}/mahaprasad/book`,
//         { mahaprasad_date_id: selectedDate, name: formData.name, phone: formData.phone, email },
//         { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
//       );
//       setSuccess('🙏 Booking confirmed successfully!');
//       fetchMyBookings();
//       setFormData({ name: '', phone: '' });
//       setSelectedDate(''); setRemaining(0);
//     } catch {
//       setError('Booking failed. Please try again.');
//     }
//     setLoading(false);
//   };

//   /* ── Logout ── */
//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user_email');
//     setStep(1); setEmail(''); setOtp(''); setOtpSent(false);
//     setMyBookings([]); setDates([]);
//   };

//   /* ══════════════ STEP 1: LOGIN ══════════════ */
//   if (step === 1) {
//     return (
//       <div className="mahaprasad-booking-page">
//         <div className="mahaprasad-container">

//           {/* Page header */}
//           <div className="page-header">
//             {/* <span className="om-symbol">🕉</span> */}
//             <h1>{t('mahaprasad.pageTitle')}</h1> 
//             <p className="subtitle">Shrinath Mhaskoba Devasthan</p>
//             <div className="header-divider">
//               <span className="line" />
//               <span className="dot">✦</span>
//               <span className="line right" />
//             </div>
//           </div>

//           <div className="booking-card" style={{ maxWidth: 480, margin: '0 auto 28px' }}>
//             <p className="card-title">Devotee Login</p>
//             <div className="card-title-bar" />

//             {otpError && (
//               <div className="alert alert-danger">⚠ {otpError}</div>
//             )}

//             <div className="field-wrap">
//               <label className="field-label">Email Address</label>
//               <input
//                 className="form-control"
//                 placeholder="Enter your email"
//                 value={email}
//                 onChange={e => setEmail(e.target.value)}
//                 type="email"
//               />
//             </div>

//             {otpSent && (
//               <div className="field-wrap">
//                 <label className="field-label">One-Time Password</label>
//                 <input
//                   className="form-control"
//                   placeholder="Enter 6-digit OTP"
//                   value={otp}
//                   onChange={e => setOtp(e.target.value)}
//                   type="text"
//                   maxLength={6}
//                   style={{ letterSpacing: '0.3em', fontSize: '1.15rem' }}
//                 />
//               </div>
//             )}

//             <button
//               className="btn btn-otp btn-full"
//               onClick={otpSent ? verifyOtp : sendOtp}
//               disabled={otpLoading}
//             >
//               {otpLoading
//                 ? '⏳ Processing…'
//                 : otpSent
//                 ? '✓ Verify OTP & Continue'
//                 : '📧 Send OTP'}
//             </button>

//             {otpSent && (
//               <p style={{ textAlign: 'center', marginTop: 12, fontSize: '0.82rem', color: 'var(--text-muted)' }}>
//                 Didn't receive?{' '}
//                 <button
//                   style={{ background: 'none', border: 'none', color: 'var(--dark-red)', fontWeight: 700, cursor: 'pointer', fontSize: 'inherit' }}
//                   onClick={sendOtp}
//                 >
//                   Resend
//                 </button>
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* ══════════════ STEP 2: BOOKING DASHBOARD ══════════════ */
//   return (
//     <div className="mahaprasad-booking-page">
//       <div className="mahaprasad-container">

//         {/* Page header */}
//         <div className="page-header">
//           {/* <span className="om-symbol">🕉</span> */}
//           <h1>Mahaprasad Booking</h1>
//           <p className="subtitle">Shrinath Mhaskoba Devasthan</p>
//           <div className="header-divider">
//             <span className="line" />
//             <span className="dot">✦</span>
//             <span className="line right" />
//           </div>
//         </div>

//         {/* ── Booking Form Card ── */}
//         <div className="booking-card">
//           <p className="card-title">Reserve Your Seat</p>
//           <div className="card-title-bar" />

//           {/* User strip */}
//           <div className="user-strip">
//             <span>Logged in as <strong>{email}</strong></span>
//             <button className="btn-logout" onClick={handleLogout}>Logout</button>
//           </div>

//           {error   && <div className="alert alert-danger">⚠ {error}</div>}
//           {success && <div className="alert alert-success">{success}</div>}

//           {/* Date select */}
//           <div className="field-wrap">
//             <label className="field-label">Select Mahaprasad Date</label>
//             <select
//               className="form-select"
//               value={selectedDate}
//               onChange={e => { setSelectedDate(e.target.value); setError(''); setSuccess(''); }}
//             >
//               <option value="">— Choose a date —</option>
//               {dates.map(d => (
//                 <option key={d.id} value={d.id} disabled={d.remaining === 0}>
//                   {d.event_date}
//                   {d.event_details ? ` · ${d.event_details}` : ''}
//                   {' '}— {d.remaining > 0 ? `${d.remaining} slots left` : 'Full'}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Slots available */}
//           {selectedDate && remaining > 0 && (
//             <div className="slots-badge">
//               <span className="dot" />
//               {remaining} slots available for this date
//             </div>
//           )}

//           {/* Booking fields */}
//           {selectedDate && remaining > 0 && (
//             <>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
//                 <div className="field-wrap" style={{ margin: 0 }}>
//                   <label className="field-label">Full Name *</label>
//                   <input
//                     className="form-control"
//                     placeholder="Your full name"
//                     value={formData.name}
//                     onChange={e => setFormData({ ...formData, name: e.target.value })}
//                   />
//                 </div>
//                 <div className="field-wrap" style={{ margin: 0 }}>
//                   <label className="field-label">Phone Number *</label>
//                   <input
//                     className="form-control"
//                     placeholder="10-digit mobile number"
//                     value={formData.phone}
//                     onChange={e => setFormData({ ...formData, phone: e.target.value })}
//                     type="tel"
//                   />
//                 </div>
//               </div>

//               <div className="field-wrap" style={{ marginTop: 16 }}>
//                 <label className="field-label">Email</label>
//                 <input
//                   className="form-control"
//                   value={email}
//                   disabled
//                 />
//               </div>

//               <button
//                 className="btn btn-success btn-full"
//                 style={{ marginTop: 6 }}
//                 onClick={handleBook}
//                 disabled={loading}
//               >
//                 {loading
//                   ? '⏳ Processing…'
//                   : `🙏 Confirm Booking · ${remaining} slots left`}
//               </button>
//             </>
//           )}

//           {selectedDate && remaining === 0 && (
//             <div className="alert alert-danger" style={{ marginTop: 10 }}>
//               ⚠ Sorry, this date is fully booked. Please choose another date.
//             </div>
//           )}
//         </div>

//         {/* ── My Bookings Card ── */}
//         <div className="booking-card">
//           <p className="card-title">My Bookings</p>
//           <div className="card-title-bar" />

//           {myBookings.length === 0 ? (
//             <div className="empty-state">
//               <span className="icon">📋</span>
//               <p>You have no bookings yet.<br />Select a date above to get started.</p>
//             </div>
//           ) : (
//             <div className="bookings-table-wrap">
//               <table className="my-bookings-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Name</th>
//                     <th>Phone</th>
//                     <th className="hide-mobile">Email</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {myBookings.map(b => (
//                     <tr key={b.id}>
//                       <td style={{ whiteSpace: 'nowrap' }}>{b.date?.event_date}</td>
//                       <td>{b.name}</td>
//                       <td style={{ whiteSpace: 'nowrap' }}>{b.phone}</td>
//                       <td className="hide-mobile" style={{ color: 'var(--text-muted)', fontSize: '0.83rem' }}>{b.email}</td>
//                       <td><StatusPill status={b.status} /></td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>

//       </div>
//     </div>
//   );
// }

// export default MahaprasadBooking;







// import { useState, useEffect } from 'react';
// import { useLanguage } from '../context/LanguageContext';
// import axios from 'axios';
// import './MahaprasadBooking.css';

// const API_BASE = 'http://localhost:8000/api';

// /* Status Pill Component */
// function StatusPill({ status }) {
//   const cls = {
//     confirmed: 'status-confirmed',
//     shifted:   'status-shifted',
//     cancelled: 'status-cancelled',
//   }[status?.toLowerCase()] || 'status-pending';

//   return <span className={`status-pill ${cls}`}>{status}</span>;
// }

// function MahaprasadBooking() {
//   const { t } = useLanguage();   // ← This is correct

//   /* ── Login state ── */
//   const [step, setStep] = useState(1);
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpLoading, setOtpLoading] = useState(false);
//   const [otpError, setOtpError] = useState('');

//   /* ── Booking state ── */
//   const [dates, setDates] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [remaining, setRemaining] = useState(0);
//   const [formData, setFormData] = useState({ name: '', phone: '' });
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [myBookings, setMyBookings] = useState([]);

//   /* Auto login on refresh */
//   useEffect(() => {
//     const token = localStorage.getItem('token');
//     const savedEmail = localStorage.getItem('user_email');
//     if (token && savedEmail) {
//       setEmail(savedEmail);
//       setStep(2);
//       fetchMyBookings();
//     }
//   }, []);

//   /* Fetch available dates */
//   useEffect(() => {
//     if (step !== 2) return;
//     axios.get(`${API_BASE}/mahaprasad`)
//       .then(res => setDates(res.data))
//       .catch(console.error);
//   }, [step]);

//   /* Fetch remaining slots */
//   useEffect(() => {
//     if (!selectedDate) return;
//     axios.get(`${API_BASE}/mahaprasad/slots/${selectedDate}`)
//       .then(res => setRemaining(res.data.remaining || 0))
//       .catch(console.error);
//   }, [selectedDate]);

//   const sendOtp = async () => {
//     if (!email) {
//       setOtpError(t('mahaprasad.enterEmail') || 'Please enter your email');
//       return;
//     }
//     setOtpLoading(true);
//     setOtpError('');
//     try {
//       await axios.post(`${API_BASE}/send-otp`, { email });
//       setOtpSent(true);
//     } catch {
//       setOtpError('Failed to send OTP');
//     }
//     setOtpLoading(false);
//   };

//   const verifyOtp = async () => {
//     try {
//       const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
//       localStorage.setItem('token', res.data.token);
//       localStorage.setItem('user_email', email);
//       setStep(2);
//       fetchMyBookings();
//     } catch {
//       setOtpError('Invalid OTP');
//     }
//   };

//   const fetchMyBookings = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/mahaprasad/my-bookings`, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//       });
//       setMyBookings(res.data || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleBook = async () => {
//     if (!selectedDate || !formData.name || !formData.phone) {
//       setError(t('mahaprasad.fillAllFields') || 'Please fill all fields');
//       return;
//     }

//     setLoading(true);
//     setError('');
//     setSuccess('');

//     try {
//       await axios.post(`${API_BASE}/mahaprasad/book`, {
//         mahaprasad_date_id: selectedDate,
//         name: formData.name,
//         phone: formData.phone,
//         email: email
//       }, {
//         headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
//       });

//       setSuccess(t('mahaprasad.bookingSuccess') || '🙏 Booking confirmed successfully!');
//       fetchMyBookings();

//       setFormData({ name: '', phone: '' });
//       setSelectedDate('');
//       setRemaining(0);
//     } catch (err) {
//       setError(t('mahaprasad.bookingFailed') || 'Booking failed. Please try again.');
//     }
//     setLoading(false);
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user_email');
//     setStep(1);
//     setEmail('');
//     setOtp('');
//     setOtpSent(false);
//     setMyBookings([]);
//   };

//   /* STEP 1: Login */
//   if (step === 1) {
//     return (
//       <div className="mahaprasad-booking-page">
//         <div className="mahaprasad-container">
//           <div className="page-header">
//             <h1>{t('mahaprasad.pageTitle')}</h1>
//             <p className="subtitle">{t('mahaprasad.subtitle')}</p>
//           </div>

//           <div className="booking-card" style={{ maxWidth: 480, margin: '0 auto 28px' }}>
//             <p className="card-title">{t('mahaprasad.devoteeLogin')}</p>

//             {otpError && <div className="alert alert-danger">⚠ {otpError}</div>}

//             <div className="field-wrap">
//               <label className="field-label">{t('mahaprasad.emailAddress')}</label>
//               <input
//                 className="form-control"
//                 placeholder={t('mahaprasad.enterEmail')}
//                 value={email}
//                 onChange={e => setEmail(e.target.value)}
//                 type="email"
//               />
//             </div>

//             {otpSent && (
//               <div className="field-wrap">
//                 <label className="field-label">{t('mahaprasad.otpPlaceholder')}</label>
//                 <input
//                   className="form-control"
//                   placeholder={t('mahaprasad.otpPlaceholder')}
//                   value={otp}
//                   onChange={e => setOtp(e.target.value)}
//                   type="text"
//                   maxLength={6}
//                 />
//               </div>
//             )}

//             <button
//               className="btn btn-otp btn-full"
//               onClick={otpSent ? verifyOtp : sendOtp}
//               disabled={otpLoading}
//             >
//               {otpLoading ? '⏳ Processing…' : otpSent ? t('mahaprasad.verifyOtp') : t('mahaprasad.sendOtp')}
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* STEP 2: Main Booking Dashboard */
//   return (
//     <div className="mahaprasad-booking-page">
//       <div className="mahaprasad-container">

//         <div className="page-header">
//           <h1>{t('mahaprasad.pageTitle')}</h1>
//           <p className="subtitle">{t('mahaprasad.subtitle')}</p>
//         </div>

//         {/* Booking Form */}
//         <div className="booking-card">
//           <p className="card-title">{t('mahaprasad.reserveYourSeat')}</p>

//           <div className="user-strip">
//             <span>{t('mahaprasad.loggedInAs')} <strong>{email}</strong></span>
//             <button className="btn-logout" onClick={handleLogout}>{t('mahaprasad.logout')}</button>
//           </div>

//           {error && <div className="alert alert-danger">⚠ {error}</div>}
//           {success && <div className="alert alert-success">{success}</div>}

//           <div className="field-wrap">
//             <label className="field-label">{t('mahaprasad.selectDate')}</label>
//             <select
//               className="form-select"
//               value={selectedDate}
//               onChange={e => setSelectedDate(e.target.value)}
//             >
//               <option value="">{t('mahaprasad.chooseDate')}</option>
//               {dates.map(d => (
//                 <option key={d.id} value={d.id} disabled={d.remaining === 0}>
//                   {d.event_date} {d.event_details ? `· ${d.event_details}` : ''} 
//                   — {d.remaining > 0 ? `${d.remaining} ${t('mahaprasad.slotsLeft')}` : t('mahaprasad.full')}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {selectedDate && remaining > 0 && (
//             <>
//               <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
//                 <div className="field-wrap">
//                   <label className="field-label">{t('mahaprasad.fullName')}</label>
//                   <input
//                     className="form-control"
//                     placeholder={t('mahaprasad.fullName')}
//                     value={formData.name}
//                     onChange={e => setFormData({ ...formData, name: e.target.value })}
//                   />
//                 </div>
//                 <div className="field-wrap">
//                   <label className="field-label">{t('mahaprasad.phoneNumber')}</label>
//                   <input
//                     className="form-control"
//                     placeholder={t('mahaprasad.phoneNumber')}
//                     value={formData.phone}
//                     onChange={e => setFormData({ ...formData, phone: e.target.value })}
//                     type="tel"
//                   />
//                 </div>
//               </div>

//               <button
//                 className="btn btn-success btn-full"
//                 style={{ marginTop: 16 }}
//                 onClick={handleBook}
//                 disabled={loading}
//               >
//                 {loading ? t('mahaprasad.processing') : `🙏 ${t('mahaprasad.confirmBooking')} · ${remaining} ${t('mahaprasad.slotsLeft')}`}
//               </button>
//             </>
//           )}
//         </div>

//         {/* My Bookings */}
//         <div className="booking-card">
//           <p className="card-title">{t('mahaprasad.myBookings')}</p>

//           {myBookings.length === 0 ? (
//             <div className="empty-state">
//               <p>{t('mahaprasad.noBookingsYet')}</p>
//             </div>
//           ) : (
//             <table className="my-bookings-table">
//               <thead>
//                 <tr>
//                   <th>{t('mahaprasad.date')}</th>
//                   <th>{t('mahaprasad.name')}</th>
//                   <th>{t('mahaprasad.phone')}</th>
//                   <th>{t('mahaprasad.status')}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {myBookings.map(b => (
//                   <tr key={b.id}>
//                     <td>{b.date?.event_date}</td>
//                     <td>{b.name}</td>
//                     <td>{b.phone}</td>
//                     <td><StatusPill status={b.status} /></td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default MahaprasadBooking;




import { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import axios from 'axios';
import './MahaprasadBooking.css';

const API_BASE = 'https://mhaskobaadmin.tipic.in/api';

/* ── Status Pill ── */
function StatusPill({ status }) {
  const cls = {
    confirmed: 'status-confirmed',
    shifted:   'status-shifted',
    cancelled: 'status-cancelled',
  }[status?.toLowerCase()] || 'status-pending';

  return <span className={`status-pill ${cls}`}>{status}</span>;
}

/* ── Cinematic Hero (same pattern as Contact / Booking pages) ── */
function MahaprasadHero({ title, subtitle }) {
  return (
    <div className="mahaprasad-hero">
      <div className="mahaprasad-hero-bg" />
      <div className="mahaprasad-hero-overlay" />
      <div className="mahaprasad-hero-rays">
        <div className="hero-ray hero-ray-1" />
        <div className="hero-ray hero-ray-2" />
        <div className="hero-ray hero-ray-3" />
        <div className="hero-ray hero-ray-4" />
        <div className="hero-ray hero-ray-5" />
      </div>
      <div className="mahaprasad-hero-content">
        <span className="hero-pill">🕉 Sacred Prasad</span>
        <h1 className="hero-title">{title}</h1>
        <div className="hero-divider">
          <span className="hd-line" />
          <span className="hd-diamond">◆</span>
          <span className="hd-line" />
        </div>
      </div>
      <div className="hero-bottom-line" />
    </div>
  );
}

function MahaprasadBooking() {
  const { t } = useLanguage();

  /* ── Login state ── */
  const [step, setStep]             = useState(1);
  const [email, setEmail]           = useState('');
  const [otp, setOtp]               = useState('');
  const [otpSent, setOtpSent]       = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError]     = useState('');

  /* ── Booking state ── */
  const [dates, setDates]               = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [remaining, setRemaining]       = useState(0);
  const [formData, setFormData]         = useState({ name: '', phone: '' });
  const [error, setError]               = useState('');
  const [success, setSuccess]           = useState('');
  const [loading, setLoading]           = useState(false);
  const [myBookings, setMyBookings]     = useState([]);

  /* Auto login on refresh */
  useEffect(() => {
    const token      = localStorage.getItem('token');
    const savedEmail = localStorage.getItem('user_email');
    if (token && savedEmail) {
      setEmail(savedEmail);
      setStep(2);
      fetchMyBookings();
    }
  }, []);

  /* Fetch available dates */
  useEffect(() => {
    if (step !== 2) return;
    axios.get(`${API_BASE}/mahaprasad`)
      .then(res => setDates(res.data))
      .catch(console.error);
  }, [step]);

  /* Fetch remaining slots */
  useEffect(() => {
    if (!selectedDate) return;
    axios.get(`${API_BASE}/mahaprasad/slots/${selectedDate}`)
      .then(res => setRemaining(res.data.remaining || 0))
      .catch(console.error);
  }, [selectedDate]);

  const sendOtp = async () => {
    if (!email) { setOtpError(t('mahaprasad.enterEmail') || 'Please enter your email'); return; }
    setOtpLoading(true); setOtpError('');
    try {
      await axios.post(`${API_BASE}/send-otp`, { email });
      setOtpSent(true);
    } catch {
      setOtpError('Failed to send OTP');
    }
    setOtpLoading(false);
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post(`${API_BASE}/verify-otp`, { email, otp });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user_email', email);
      setStep(2);
      fetchMyBookings();
    } catch {
      setOtpError('Invalid OTP. Please try again.');
    }
  };

  const fetchMyBookings = async () => {
    try {
      const res = await axios.get(`${API_BASE}/mahaprasad/my-bookings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setMyBookings(res.data || []);
    } catch (err) { console.error(err); }
  };

  const handleBook = async () => {
    if (!selectedDate || !formData.name || !formData.phone) {
      setError(t('mahaprasad.fillAllFields') || 'Please fill all fields');
      return;
    }
    setLoading(true); setError(''); setSuccess('');
    try {
      await axios.post(`${API_BASE}/mahaprasad/book`, {
        mahaprasad_date_id: selectedDate,
        name: formData.name,
        phone: formData.phone,
        email,
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

      setSuccess(t('mahaprasad.bookingSuccess') || '🙏 Booking confirmed successfully!');
      fetchMyBookings();
      setFormData({ name: '', phone: '' });
      setSelectedDate(''); setRemaining(0);
    } catch {
      setError(t('mahaprasad.bookingFailed') || 'Booking failed. Please try again.');
    }
    setLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user_email');
    setStep(1); setEmail(''); setOtp(''); setOtpSent(false); setMyBookings([]);
  };

  /* ══════ STEP 1: Login ══════ */
  if (step === 1) {
    return (
      <div className="mahaprasad-booking-page">
        <MahaprasadHero
          title={t('mahaprasad.pageTitle') || 'Mahaprasad Booking'}
          subtitle={t('mahaprasad.subtitle') || 'Shrinath Mhaskoba Devasthan'}
        />

        <div className="mahaprasad-body-wrap">
          <div className="mahaprasad-container">
            <div className="booking-card" style={{ maxWidth: 480, margin: '0 auto' }}>
              <p className="card-title">{t('mahaprasad.devoteeLogin') || 'Devotee Login'}</p>
              <div className="card-title-bar" />

              {otpError && <div className="alert alert-danger">⚠ {otpError}</div>}

              <div className="field-wrap">
                <label className="field-label">{t('mahaprasad.emailAddress') || 'Email Address'}</label>
                <input
                  className="form-control"
                  placeholder={t('mahaprasad.enterEmail') || 'Enter your email'}
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  type="email"
                />
              </div>

              {otpSent && (
                <div className="field-wrap">
                  <label className="field-label">{t('mahaprasad.otpPlaceholder') || 'One-Time Password'}</label>
                  <input
                    className="form-control"
                    placeholder={t('mahaprasad.otpPlaceholder') || '6-digit OTP'}
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                    type="text"
                    maxLength={6}
                    style={{ letterSpacing: '0.3em', fontSize: '1.1rem' }}
                  />
                </div>
              )}

              <button
                className="btn btn-otp btn-full"
                onClick={otpSent ? verifyOtp : sendOtp}
                disabled={otpLoading}
              >
                {otpLoading
                  ? '⏳ Processing…'
                  : otpSent
                  ? t('mahaprasad.verifyOtp') || '✓ Verify OTP'
                  : t('mahaprasad.sendOtp') || '📧 Send OTP'}
              </button>

              {otpSent && (
                <p style={{ textAlign: 'center', marginTop: 12, fontSize: '0.82rem', color: 'var(--text-muted)' }}>
                  Didn't receive?{' '}
                  <button
                    style={{ background: 'none', border: 'none', color: 'var(--dark-red)', fontWeight: 700, cursor: 'pointer', fontSize: 'inherit' }}
                    onClick={sendOtp}
                  >
                    Resend
                  </button>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ══════ STEP 2: Booking Dashboard ══════ */
  return (
    <div className="mahaprasad-booking-page">
      <MahaprasadHero
        title={t('mahaprasad.pageTitle') || 'Mahaprasad Booking'}
        subtitle={t('mahaprasad.subtitle') || 'Shrinath Mhaskoba Devasthan'}
      />

      <div className="mahaprasad-body-wrap">
        <div className="mahaprasad-container">

          {/* ── Booking Form card ── */}
          <div className="booking-card">
            <p className="card-title">{t('mahaprasad.reserveYourSeat') || 'Reserve Your Seat'}</p>
            <div className="card-title-bar" />

            <div className="user-strip">
              <span>{t('mahaprasad.loggedInAs') || 'Logged in as'} <strong>{email}</strong></span>
              <button className="btn-logout" onClick={handleLogout}>{t('mahaprasad.logout') || 'Logout'}</button>
            </div>

            {error   && <div className="alert alert-danger">⚠ {error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <div className="field-wrap">
              <label className="field-label">{t('mahaprasad.selectDate') || 'Select Date'}</label>
              <select
                className="form-select"
                value={selectedDate}
                onChange={e => { setSelectedDate(e.target.value); setError(''); setSuccess(''); }}
              >
                <option value="">{t('mahaprasad.chooseDate') || '— Choose a date —'}</option>
                {dates.map(d => (
                  <option key={d.id} value={d.id} disabled={d.remaining === 0}>
                    {d.event_date}
                    {d.event_details ? ` · ${d.event_details}` : ''}
                    {' '}— {d.remaining > 0
                      ? `${d.remaining} ${t('mahaprasad.slotsLeft') || 'slots left'}`
                      : t('mahaprasad.full') || 'Full'}
                  </option>
                ))}
              </select>
            </div>

            {selectedDate && remaining > 0 && (
              <>
                <div className="slots-badge">
                  <span className="dot" />
                  {remaining} {t('mahaprasad.slotsLeft') || 'slots available'}
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                  <div className="field-wrap" style={{ margin: 0 }}>
                    <label className="field-label">{t('mahaprasad.fullName') || 'Full Name'} *</label>
                    <input
                      className="form-control"
                      placeholder={t('mahaprasad.fullName') || 'Your full name'}
                      value={formData.name}
                      onChange={e => setFormData({ ...formData, name: e.target.value })}
                    />
                  </div>
                  <div className="field-wrap" style={{ margin: 0 }}>
                    <label className="field-label">{t('mahaprasad.phoneNumber') || 'Phone Number'} *</label>
                    <input
                      className="form-control"
                      placeholder={t('mahaprasad.phoneNumber') || '10-digit mobile'}
                      value={formData.phone}
                      onChange={e => setFormData({ ...formData, phone: e.target.value })}
                      type="tel"
                       maxLength={10}
                    />
                  </div>
                </div>

                <button
                  className="btn btn-success btn-full"
                  style={{ marginTop: 20 }}
                  onClick={handleBook}
                  disabled={loading}
                >
                  {loading
                    ? t('mahaprasad.processing') || '⏳ Processing…'
                    : `🙏 ${t('mahaprasad.confirmBooking') || 'Confirm Booking'} · ${remaining} ${t('mahaprasad.slotsLeft') || 'slots left'}`}
                </button>
              </>
            )}

            {selectedDate && remaining === 0 && (
              <div className="alert alert-danger" style={{ marginTop: 10 }}>
                ⚠ Sorry, this date is fully booked. Please choose another date.
              </div>
            )}
          </div>

          {/* ── My Bookings card ── */}
          <div className="booking-card">
            <p className="card-title">{t('mahaprasad.myBookings') || 'My Bookings'}</p>
            <div className="card-title-bar" />

            {myBookings.length === 0 ? (
              <div className="empty-state">
                <span className="icon">📋</span>
                <p>{t('mahaprasad.noBookingsYet') || 'You have no bookings yet.'}</p>
              </div>
            ) : (
              <div className="bookings-table-wrap">
                <table className="my-bookings-table">
                  <thead>
                    <tr>
                      <th>{t('mahaprasad.date') || 'Date'}</th>
                      <th>{t('mahaprasad.name') || 'Name'}</th>
                      <th>{t('mahaprasad.phone') || 'Phone'}</th>
                      <th className="hide-mobile">{t('mahaprasad.email') || 'Email'}</th>
                      <th>{t('mahaprasad.status') || 'Status'}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myBookings.map(b => (
                      <tr key={b.id}>
                        <td style={{ whiteSpace: 'nowrap' }}>{b.date?.event_date}</td>
                        <td>{b.name}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{b.phone}</td>
                        <td className="hide-mobile" style={{ color: 'var(--text-muted)', fontSize: '0.83rem' }}>{b.email}</td>
                        <td><StatusPill status={b.status} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default MahaprasadBooking;